"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Preview/components/ProgramTable.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    ProgramOutline_template = require("../../../components/ProgramOutline.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    ProgramOutline_tag = marko_loadTag(ProgramOutline_template),
    marko_attrs0 = {
        "class": "program-table"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (Array.isArray(input.list) && input.list.length) {
    out.be("div", marko_attrs0, "0", component);

    marko_forOf(input.list, function(course, index) {
      ProgramOutline_tag(course, out, __component, index);
    });

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
